import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ccba0ed2")

_pushScopeId("data-v-ccba0ed2")
const _hoisted_1 = { id: "entire_app__availableroutes" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title_container" }, [
  /*#__PURE__*/_createVNode("svg", {
    id: "pulse-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      id: "Path_31",
      "data-name": "Path 31",
      d: "M0,0H24V24H0Z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "Path_32",
      "data-name": "Path 32",
      d: "M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z",
      fill: "#1d2329"
    })
  ]),
  /*#__PURE__*/_createVNode("h2", null, "All available routes and bookings")
], -1)
const _hoisted_3 = { class: "entire_transport_means__body_content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ])
  ]))
})